<template>
  <admin-table v-if="userData.type == 'admin'" />
  <partners-table v-else />
</template>

<script>
import AdminTable from "./admin/table.vue";
import PartnersTable from "./partners/table.vue";

export default {
  components: {
    AdminTable,
    PartnersTable,
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData;
    },
  },
};
</script>

<style></style>
